import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import './styles.scss'
import inchatActions from 'redux/inchat/actions'
import Message from 'components/InChatView/ChatMessages/Message'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'
import { toastMessage } from 'utils/messages'
import { getFormatedDate } from 'utils'

const aditionalContent = (params = {}) => {
  const {
    message, getDrafts, setMessageTemp, toggleScheduleMsgModal, toggleDelete, dispatch, push, location
  } = params

  const sendMessage = async () => {
    const _composer = {
      type: 'direct',
      conversationId: message.conversationInfo._id,
      message: message.content,
      attachments: message.attachments?.length > 0 ? message.attachments : undefined,
      parentId: message.isThread ? message.parentId : undefined,
      draftId: message._id,
    }
    try {
      await dispatch(inchatActions.sendMessage(message.conversationInfo._id, message.isThread, _composer))
      toastMessage(lang('inchat_message_sent'), 'info')
      getDrafts()
    } catch (error) {
      toastMessage(lang('inchat_error_message_sent'), 'error')
    }
  }

  const editMessage = () => {
    if (!message.conversationInfo._id) return
    dispatch(inchatActions.setDraftId(message._id))
    // RUTEAR AL CHAT
    push(`${location.pathname}?user_id=${message.conversationInfo._id}`)
  }

  return (
    <div className='actions'>
      <div className='buttons'>
        <span
          className='time'
          title={lang('inchat_title_schedule_message')}
          onClick={() => {
            setMessageTemp(message)
            toggleScheduleMsgModal()
          }}
        >
          <img src={getStaticImage('/icons/orange-brand/icon-clock-dark.svg')} alt='schedule' />
        </span>

        <span
          className='send'
          title={lang('dashboard_send-message')}
          onClick={sendMessage}
        >
          <img src={getStaticImage('/icons/orange-brand/icon-send-alt.svg')} alt='send' />
        </span>

        <span
          className='edit'
          title={lang('dashboard_edit-message')}
          onClick={editMessage}
        >
          <img src={getStaticImage('/icons/orange-brand/icon-edit.svg')} alt='edit' />
        </span>

        <span
          className='remove'
          title={lang('dashboard_delete-message')}
          onClick={() => {
            setMessageTemp(message)
            toggleDelete()
          }}
        >
          <img src={getStaticImage('/icons/orange-brand/icon-delete.svg')} alt='delete' />
        </span>
      </div>
      <span className='message-time'>{getFormatedDate({ isoString: message.createdAt, withTime: true, withYear: true })}</span>
    </div>
  )
}

const getMessage = (params = {}) => {
  const {
    message, getDrafts, setMessageTemp, toggleScheduleMsgModal, toggleDelete, dispatch, push, location
  } = params

  const { conversationInfo } = message
  const user = conversationInfo.type === 'channel' ? {
    name: `# ${conversationInfo.name}`,
    lastname: '',
    picture: null
  } : {
    ...conversationInfo.usersInfo[1]
  }

  return (
    <Message
      key={message._id}
      message={{
        ...message,
        text: message.content,
        user: user
      }}
      showOptions={false}
      showReactions={false}
      aditionalContent={message => aditionalContent({
        message, getDrafts, setMessageTemp, toggleScheduleMsgModal, toggleDelete, dispatch, push, location
      })}
    />
  )
}

const DraftsContent = props => {
  const { count, drafts, getDrafts, setMessageTemp, toggleScheduleMsgModal, toggleDelete } = props
  const dispatch = useDispatch()
  const { push } = useHistory()
  const location = useLocation()

  return (
    <>
      {!count ? (
        <div className='no-content'>
          <img src={getStaticImage('/icons/orange-brand/icon-empty.svg')} alt='No drafts' />
          <span>{lang('inchat_no_drafts')}</span>
        </div>
      ) : null}
      {drafts.map((message, index) => (
        <div key={index} className='message-wrapper'>
          {getMessage({
            message, getDrafts, setMessageTemp, toggleScheduleMsgModal, toggleDelete, dispatch, push, location
          })}
        </div>
      ))}
    </>
  )
}

export default DraftsContent
